import { Row, Col, Flex, Text } from "@/base/index";
import { useFooterNavigateStyles } from "./footer-navigate.styles";
import { LocalizationText } from "@/app/index";
import { useMenu } from "@/app/hook/use-menu";
import { Link } from "@/components/link";

export const FooterNavigateMenu = () => {
  const { styles } = useFooterNavigateStyles();
  const footerMenuItems = useMenu("footer");

  const renderItems = (items: any) =>
    (items || []).map((item: any) => (
      <Link key={item.id} to={item.href} target="_self">
        {<LocalizationText value={`footer.menu.item.text.${item.id}`} />}
      </Link>
    ));

  return (
    <div className={styles.menu}>
      <Row gutter={[32, 32]}>
        {footerMenuItems?.map((item) => (
          <Col key={item.id} xs={{ flex: `50%` }} md={{ flex: `25%` }}>
            <Flex gap={12} vertical>
              <Text strong>
                <LocalizationText value={`footer.menu.item.text.${item.id}`} />
              </Text>
              <Flex gap={8} vertical>
                {renderItems(item.children)}
              </Flex>
            </Flex>
          </Col>
        ))}
      </Row>
    </div>
  );
};
